import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FinCENApi } from 'api';
import { FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useRefileFincenExportRecord(exportRecordId: string) {
  const { userBankId } = useUser();
  const fincenApi = new FinCENApi();
  const queryClient = useQueryClient();

  const { mutateAsync: refileFincenExportRecord, isPending: isLoadingRefileFincenExportRecord } = useMutation(
    {
      mutationKey: [FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY],
      mutationFn: () => fincenApi.refileFincenExportRecord(userBankId, exportRecordId),
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: [FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY, userBankId, data.exportRecordId]
        });
      }
    }
  );

  return { refileFincenExportRecord, isLoadingRefileFincenExportRecord };
}
